var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "57px",
    height: "43px",
    viewBox: "0 0 57 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "61C920BC-F4D6-4B7E-B9C6-63B55646474D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[[D]]-Business",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "business-user-timeline-empty",
    transform: "translate(-357.000000, -1478.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-1",
    transform: "translate(0.000000, 503.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Block-3",
    transform: "translate(337.000000, 899.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration",
    transform: "translate(20.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3432169,1 L8,1 C6.8954305,1 6,1.8954305 6,3 L6,12 C6,13.1045695 6.8954305,14 8,14 L50,14 C51.1045695,14 52,13.1045695 52,12 L52,7.86486486 C52,6.76029537 51.1045695,5.86486486 50,5.86486486 L25.9703057,5.86486486 L21.3432169,1 Z",
    id: "Rectangle-Copy",
    stroke: "#F7B500",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.45178846,14 C3.35853557,14 3.26539684,14.0065221 3.17305402,14.0195185 C2.07926427,14.1734592 1.31736615,15.1849447 1.47130693,16.2787344 L4.8490847,40.2787344 C4.98801666,41.2658825 5.83268938,42 6.82956624,42 L50.1704338,42 C51.1673106,42 52.0119833,41.2658825 52.1509153,40.2787344 L55.5286931,16.2787344 C55.5416895,16.1863916 55.5482115,16.0932529 55.5482115,16 C55.5482115,14.8954305 54.652781,14 53.5482115,14 L3.45178846,14 Z",
    id: "Rectangle",
    stroke: "#F7B500",
    strokeWidth: 2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,25 C35,26.1045661 34.104598,27 33,27 C31.8954339,27 31,26.1045661 31,25 C31,23.8955614 31.8954339,23 33,23 C34.104598,23 35,23.8955614 35,25",
    id: "Fill-7-Copy",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,25 C26,26.1045661 25.104598,27 24,27 C22.8954339,27 22,26.1045661 22,25 C22,23.8955614 22.8954339,23 24,23 C25.104598,23 26,23.8955614 26,25",
    id: "Fill-7-Copy-2",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5,33 C26.5670093,33 25,31.6568492 25,30 C25,30 32,30 32,30 C32,31.6568492 30.4330465,33 28.5,33 Z",
    id: "Fill-7-Copy-3",
    fill: "#F7B500"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.2e5ff267b89c8a761abeb59596fb588e.svg";
export { ForwardRef as ReactComponent };